import { PersonalizedNotificationTemplatesScreen } from "./personalized-notification-templates.screen";
import { Paths } from "../../routes/paths";
import { type RouteDefinition } from "../../routes/route-definition";
import { PersonalizedNotificationTemplateEditRoutes } from "../personalized-notification-template-edit";

export const PersonalizedNotificationTemplatesRoutes: RouteDefinition[] = [
	{
		path: Paths.personalizedNotificationTemplates.path,
		element: <PersonalizedNotificationTemplatesScreen />,
		// TODO: better permissions
		requiredPermissions: ["AccountPermission_System_Root"],
	},
	...PersonalizedNotificationTemplateEditRoutes,
];
